import Collapse, { CollapseProps } from '@mui/material/Collapse'
import Fade, { FadeProps } from '@mui/material/Fade'
import Grow, { GrowProps } from '@mui/material/Grow'
import Slide, { SlideProps } from '@mui/material/Slide'
import Zoom, { ZoomProps } from '@mui/material/Zoom'
import * as React from 'react'

interface AnimationsPropsMapping {
  collapse: Pick<CollapseProps, 'component' | 'in' | 'timeout'>
  fade: Pick<FadeProps, 'in' | 'timeout'>
  grow: Pick<GrowProps, 'in' | 'timeout'>
  slide: Pick<SlideProps, 'direction' | 'in' | 'timeout'>
  zoom: Pick<ZoomProps, 'in' | 'timeout'>
}

const animations = {
  collapse: Collapse,
  fade: Fade,
  grow: Grow,
  slide: Slide,
  zoom: Zoom,
}

interface Props<V> {
  variant: V
  children?: React.ReactNode
}

// The any below is not a problem, because we are only passing down the reference of the parent component
// The reference is already from type of the Component
// eslint-disable-next-line no-shadow
export const Animation = React.forwardRef(function Animation<V extends keyof AnimationsPropsMapping>(
  { variant, children, ...rest }: Props<V> & AnimationsPropsMapping[V],
  ref?: React.Ref<any>,
) {
  const AnimationToRender = animations[variant] as React.ComponentType<React.PropsWithChildren<unknown>>
  return (
    <AnimationToRender {...rest} ref={ref}>
      <span>{children}</span>
    </AnimationToRender>
  )
})

export default Animation
